import axios from 'axios';
import {message} from "antd";
import PATH_URL from "./url";

const Axios = axios.create({
    baseURL: PATH_URL.BASE_URL, // 设置请求的base url
    timeout: 5 * 60 * 1000, // 设置超时时长
    withCredentials: true,// 是否跨站点访问控制请求
    headers: {
        get: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        post: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }
})
/**
 * 请求拦截器
 */
Axios.interceptors.request.use(
    config => {
        const token = window.sessionStorage.getItem("token");
        token && (config.headers.token = token);
        return config;
    },
    error => {
        Promise.error(error);
    }
)
/**
 * 响应拦截器
 */
Axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.toString() === "Error: Network Error") {
            message.error("网络错误！");
            return Promise.reject(error);
        } else if (error.response && error.response.status) {
            if (error.response.status === 403) {
                window.sessionStorage.clear();
                // H5 与 PC 共用同一份代码：位于 /h5 下时回 H5 登录页，否则回 PC 登录页
                const path = window.location.pathname || '';
                const idx = path.indexOf('/h5');
                window.location.href = idx === -1 ? '/login' : path.slice(0, idx) + '/h5/login';
            }
            // 统一以 rejected 返回：避免原先 403 分支返回 undefined 导致调用方
            // .then(res => res.data) 读到 undefined 抛 TypeError
            return Promise.reject(error.response);
        } else {
            // 请求被中断（如页面切换时 abort，error.response 为空）在此兜底，
            // 避免 error.response.status 直接抛 TypeError
            return Promise.reject(error);
        }
    }
)

export default Axios

